import { render, staticRenderFns } from "./QuoteTemplates.vue?vue&type=template&id=c546c2f8"
import script from "./QuoteTemplates.vue?vue&type=script&lang=js"
export * from "./QuoteTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports